module.exports = function() {
  return new Worker(__webpack_public_path__ + "ba1f82102f76e3846631.worker.js");
};